export default {
      id: "oc-res-lbagent-usage",
      viewBox: "0 0 1025 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-lbagent",
      toString: function () {
        return this.url;
      }
    }